import React, { useMemo, useState, useEffect } from "react";
import { Switcher } from "pepsico-ds";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ComposedChart,
} from "recharts";

function parseMonthLabelToDate(label) {
    // label example: "W1 Mar 2025"
    
    const parts = label.split(" ");
    const weekStr = parts[0]; // "W1"
    const monStr = parts[1];  // "Mar"
    const year = Number(parts[2]); // 2025
  
    const monthIndex = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"].indexOf(monStr);
    const weekNumber = Number(weekStr.replace("W", "")); // extract 1 from "W1"
  
    // Set date: weekNumber * 7 gives approximate day
    const day = (weekNumber - 1) * 7 + 1;
  
    return new Date(year, monthIndex, day);
  }

export default function RisiLineChartScrollable({ rawData, lineChartactualData, forecastStartLabel, risiSeriesLineChartIndex, firstForecastYearMonth, firstForecastKeysToBeMergedActualLAst}) {

  const COL_WIDTH = 50; // pixels per month (tweak for density)
  const CHART_HEIGHT = 500; // chart drawing area height
  const VISIBLE_MIN_WIDTH = 1400; // minimum width of chart area (so small datasets don't look tiny)

  const forecastStart = forecastStartLabel;
  const forecastIndex = rawData?.findIndex((d) => d.yearMonth === forecastStart);  

  const { baseData, actualDataBySeries, forecastDataBySeries, chartWidth } = useMemo(() => {

    const baseData = rawData?.map((r, index) => {
        return { ...r, x: index + 1 };
      });


    const actualDataBySeries = {};
    const forecastDataBySeries = {};

    risiSeriesLineChartIndex?.forEach(s => {
      // const seriesForecastIndex = baseData.findIndex(
      //   row => row.yearMonth === forecastStart && row[s.key] !== null
      // );
      const lastActualIndex = lineChartactualData?.findLastIndex(row => row[s.key] != null);
      // actualDataBySeries[s.key] = baseData?.map(row => ({
      //   x: row.x,
      //   yearMonth: row.yearMonth,
      //   assessmentDate: row.assessmentDate,
      //   forecastActualMergedVal: row.yearMonth==firstForecastYearMonth ? firstForecastYearMonth : '',
      //   // [s.key]: row.x <= forecastIndex+1 ? row[s.key] : forecastIndex == -1 ? row[s.key] : null, // include cutoff in actual
      //   [s.key]: row.x <= forecastIndex ? row[s.key] : null
      // }));

      // actualDataBySeries[s.key] = baseData.map(row => ({
      //   x: row.x,
      //   yearMonth: row.yearMonth,
      //   assessmentDate: row.assessmentDate,
      //   [s.key]: row.x <= seriesForecastIndex ? row[s.key] : null
      // }));

      actualDataBySeries[s.key] = baseData.map((row, i) => ({
        x: row.x,
        yearMonth: row.yearMonth,
        assessmentDate: row.assessmentDate,
        forecastActualMergedVal: row.yearMonth==firstForecastYearMonth ? firstForecastYearMonth : '',
        [s.key]: i <= lastActualIndex+1 ? row[s.key] : null
      }));

      if (forecastIndex !== -1) {
        // forecastDataBySeries[s.key] = baseData?.map(row => ({
        //   x: row.x,
        //   yearMonth: row.yearMonth,
        //   assessmentDate: row.assessmentDate,
        //   // [s.key]: row.x >= forecastIndex + 1 ? row[s.key] : null, // include cutoff in forecast
        //   [s.key]:
        //             row.x === forecastIndex
        //               ? baseData[forecastIndex][s.key]   // copy last actual value
        //               : row.x > forecastIndex
        //               ? row[s.key]
        //               : null
        // }));
       forecastDataBySeries[s.key] = baseData.map((row, i) => ({
          x: row.x,
          yearMonth: row.yearMonth,
          assessmentDate: row.assessmentDate,
          [s.key]:
            i === lastActualIndex
              ? row[s.key]      // duplicate boundary value
              : i > lastActualIndex
              ? row[s.key]
              : null
        }));
      }
    });
      

    // compute chart width based on number of points (ensure at least VISIBLE_MIN_WIDTH)
    const computedWidth = Math.max(VISIBLE_MIN_WIDTH, baseData?.length * COL_WIDTH);

    return { baseData, actualDataBySeries, forecastDataBySeries, chartWidth: computedWidth };
  }, [rawData, forecastStartLabel]);


// const tickFormatter = (value) => {
//     const matchedData = baseData.find((data) => data.x === value);
//     return (
//       <g transform={`translate(${x},${y})`}>
//       {/* <g transform={`translate(${x},${y})`}> */}
//           <text
//               x={0}
//               y={0}
//               dy={5} // Adjust vertical alignment
//               textAnchor="end" // Align the text properly
//               transform="rotate(270)" // Rotate the text by 90 degrees
//               fill="#616161"
//               style={{ fontSize: "14px" }}
//           >
//               {matchedData ? matchedData.yearMonth : value}
//           </text>
//       </g>
//     );
//     // return matchedData ? matchedData.yearMonth : value;
//   };

const CustomizedTick = ({ x, y, payload }) => {
  const matchedData = baseData.find((data) => data.x === payload.value);
  return (
      <g transform={`translate(${x},${y})`}>
          <text
              x={0}
              y={0}
              // dx={20}
              dy={5} // Adjust vertical alignment
              textAnchor="end" // Align the text properly
              transform="rotate(270)" // Rotate the text by 90 degrees
              fill="#616161"
              style={{ fontSize: "14px" }}
          >
              {matchedData?.yearMonth}
          </text>
      </g>
  );
};
  
const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !label) return null;

  // 1) normalize label -> timestamp
  const labelTs = (typeof label === "number")
    ? label
    : (() => {
        const match = String(label).match(/([A-Za-z]{3}-\d{2})/);
        const labelStr = match ? match[1] : String(label);
        
        const d = parseMonthLabelToDate(labelStr);
        return d ? d.getTime() : NaN;
      })();

  if (!labelTs || Number.isNaN(labelTs)) return null;

  // 2) find the baseData index for this timestamp (exact match)
  const idx = baseData?.findIndex(d => d.x === labelTs);
  if (idx === -1) return null; // not exactly on a point -> no tooltip

  // 3) is forecast month?
  // const isForecastMonth = idx >= forecastIndex;
  const isForecastMonth = forecastIndex == 0 ? true : forecastIndex !== -1 &&  idx > forecastIndex;

  // 4) for each series, pick the value from appropriate masked array


  const items = risiSeriesLineChartIndex?.map(s => {

    const actualArr = actualDataBySeries?.[s.key] || [];
    const forecastArr = forecastDataBySeries?.[s.key] || [];

    const actualVal = actualArr[idx]?.[s.key] ?? null;
    const forecastVal = forecastArr[idx]?.[s.key] ?? null;

    // Find last actual index for this series
    const lastActualIndex = lineChartactualData.findLastIndex(row => row?.[s.key] != null);

    const isForecastMonthForSeries = idx > lastActualIndex;

    // Choose value
    const value = isForecastMonthForSeries
      ? (forecastVal != null ? forecastVal : actualVal)
      : (actualVal != null ? actualVal : forecastVal);

    const isForecastActualLabelMerged =
      firstForecastKeysToBeMergedActualLAst.includes(s.key) &&
      firstForecastYearMonth === actualArr?.[idx]?.['forecastActualMergedVal'];

    const stringVal =
      isForecastActualLabelMerged
        ? 'Price (Forecast)'
        : isForecastMonthForSeries
        ? 'Price (Forecast)'
        : 'Price (Actual)';

    return {
      key: s.key,
      color: s.color,
      name: s.key,
      stringVal,
      value,
    };
  });

  // 5) format label for display (Mon-YY)
  const d = new Date(labelTs);
  const formattedLabel = `${d.toLocaleString("en-US",{ month: "short" })}-${String(d.getFullYear()).slice(-2)}`;

  // 6) render tooltip showing all series
  return (
    <div style={{
      background: "#fff",
      border: "1px solid #ccc",
      borderRadius: 6,
      padding: 10,
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      fontSize: 13,
    }}>

      {items
        ?.filter(it => it.value != null)   // âœ… Only show lines that have a value
        ?.map(it => (
          <div key={it.key} style={{ marginBottom: 8, display: "flex", gap: 8, alignItems: "center" }}>
            {/* <span
              style={{
                width: 10,
                height: 10,
                borderRadius: 10,
                background: it.color,
                display: "inline-block",
                marginRight: 6,
              }}
            /> */}
            <div>
              <div ><strong>Index:</strong><span style={{ fontWeight: 600 }}>{it.key}</span></div>
              <div><strong>Assessment Date:</strong> {payload[0]?.payload?.assessmentDate}</div>
              <div>
                {/* <strong>{isForecastMonth ? "Price (Forecast)" : "Price (Actual)"}:</strong> {it.value} */}
                <strong>{it.stringVal}:</strong> {it.value}
              </div>
              <div><strong>Date:</strong> {payload[0]?.payload?.yearMonth}</div>
            </div>
          </div>
      ))}
 
    </div>
  );
};


  return (


    <>
    <ResponsiveContainer width="100%" height={350}>
      <ComposedChart
        data={baseData}
        margin={{
          top: 20,
          right: 40,
          left: 10,
          bottom: 70,
        }}
      >
        <CartesianGrid horizontal={true} vertical={false} stroke="#DFDFDF" />

        <XAxis
          dataKey="x"
          type="number"                  
          interval={0}           
          tick={<CustomizedTick />}
          domain={["dataMin", "dataMax"]}
          // tickFormatter={tickFormatter}
          ticks={baseData?.map(d => d.x)}
          // angle={-90}
          axisLine={false}
          tickLine={false}
          padding={{ left: 40, right: 20 }} 
          // margin={{bottom: 20, top: 50}}
        />
        <YAxis 
          axisLine={false}
          tickLine={false}
        />
        <Tooltip content={<CustomTooltip />} />


        {risiSeriesLineChartIndex?.map(s => (
          <React.Fragment key={s.key}>
            <Line
              data={actualDataBySeries[s.key]}
              dataKey={s.key}
              name={`${s.key} (Actual)`}
              stroke={s.color}
              strokeWidth={2}
              dot={{ fill: s.color, stroke: s.color, r: 2 }}
              isAnimationActive={false}
              connectNulls={false}
            />
            <Line
              data={forecastDataBySeries[s.key]}
              dataKey={s.key}
              name={`${s.key} (Forecast)`}
              stroke={s.color}
              strokeWidth={2}
              strokeDasharray="6 4"
              dot={{ fill: s.color, stroke: s.color, r: 2 }}
              isAnimationActive={false}
              connectNulls={false}
            />
          </React.Fragment>
        ))}
      </ComposedChart>
      </ResponsiveContainer>
      </>

  );
}
